import React from 'react';
import { statusMeta, normalizeStatus } from '../lib/opportunityStatus';

/**
 * OpportunityStatusBadge — Card P117 PR-B. One badge for the board card and
 * the list row, so Open / Won / Lost / Abandoned mean the same colour in
 * both places.
 *
 * ⚠ The word is always present. Muting a closed card is a colour signal and
 * colour alone is not a signal every rep can read; the badge is what carries
 * the meaning, the dimming only directs the eye.
 */
export default function OpportunityStatusBadge({ status, compact = false }) {
  const s = normalizeStatus(status);
  const m = statusMeta(s);
  return (
    <span
      data-testid="opp-status-badge"
      data-status={s}
      title={`Opportunity status: ${m.label}`}
      style={{
        display: 'inline-block',
        background: m.bg,
        color: m.color,
        padding: compact ? '0 5px' : '2px 8px',
        borderRadius: 10,
        fontSize: compact ? 9 : 11,
        fontWeight: 700,
        lineHeight: compact ? '14px' : '16px',
        whiteSpace: 'nowrap',
      }}
    >
      {m.label}
    </span>
  );
}
